module.exports = __webpack_public_path__ + "img/redo.be3aafa3.svg";